import axios from 'axios';
import Vue from 'vue'

export default {
    getTotalTurnover(month,year,isMonthly,isYearly,type,dbId){
        return axios.get('/api/reporting/turnover', { params: { month: month, year:year, isMonthly:isMonthly,isYearly:isYearly,type:type, dbAgencyId: dbId } } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPurchasesByBrand(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalSalesByBrand',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getQuantityByBrand(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalQuantitiesByBrand',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTopTenItems(page, pageSize,start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/topItems',{params: {page: page, pageSize: pageSize,start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTopTenItemsForHome(){
        return axios.get('/api/reporting/top-items-homepage')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTotalSales(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalSales',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersStatus(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/ordersStatus',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getInvoicesStatus(countryId,cityId,customerId){
        return axios.get('/api/reporting/invoicesStatus',{params: {countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSearchHistory(page, pageSize,start,end,customerId,itemFilter,orderOption){
        return axios.get('/api/reporting/searchHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId, itemFilter:itemFilter, orderOption:orderOption } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAccessHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/accessHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSyncHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/syncHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getLastSynchronisationAccess(){
        return axios.get('/api/reporting/lastSynchronisationAccess')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSearchHistoryChartCustomerList(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/searchHistoryChart/customer/list',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getSearchHistoryChartSupplierList(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/searchHistoryChart/supplier/list',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
            .then(response => {
                if (response && response.data) return response.data
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
     },

    getOrderHistory(page, pageSize,start,end,customerId){

        return axios.get('/api/reporting/orderHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })

        .then(response => {

            if (response && response.data) return response.data

        })

        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
    getReclamationRateYearly(customerId, claimServiceId){
        return axios.get('/api/reporting/claim/rate-yearly',{params:{customerId:customerId ,  claimServiceId:claimServiceId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRateMonthly(year,customerId, claimServiceId){
        return axios.get('/api/reporting/claim/rate-monthly',{params:{year:year,customerId:customerId ,  claimServiceId:claimServiceId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsReopened(year,customerId, claimServiceId){
        return axios.get('/api/reporting/claim/reopened',{params: {year:year,customerId:customerId ,  claimServiceId:claimServiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRateByStatus(start,end,customerId, claimServiceId,requestedPercentages){
        return axios.get('/api/reporting/claim/rate-by-status',{params: {start:start,end:end,customerId:customerId, claimServiceId:claimServiceId,requestedPercentages:requestedPercentages} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRateByBlType(start,end,customerId, claimServiceId){
        return axios.get('/api/reporting/claim/rate-by-bl-type',{params: {start:start,end:end,customerId:customerId, claimServiceId:claimServiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRateByBlDatePerHour(start,end,customerId, claimServiceId){
        return axios.get('/api/reporting/claim/rate-by-bl-date-per-hour',{params: {start:start,end:end,customerId:customerId, claimServiceId:claimServiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRateByBlDatePerWeekDay(start,end,customerId, claimServiceId){
        return axios.get('/api/reporting/claim/rate-by-bl-date-per-week-day',{params: {start:start,end:end,customerId:customerId, claimServiceId:claimServiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimIdentificationStats(start,end,customerId, claimServiceId){
        return axios.get('/api/reporting/claim/identification-stats',{params: {start:start,end:end,customerId:customerId, claimServiceId:claimServiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRateDuration(month){
        return axios.get('/api/reporting/claim/rate-duration',{params: {month:month} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRateByService(start,end,customerId){
        return axios.get('/api/reporting/claim/rate-by-service',{params: {start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRateByType(start,end,customerId, claimServiceId){
        return axios.get('/api/reporting/claim/rate-by-type',{params: {start:start,end:end,customerId:customerId, claimServiceId:claimServiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsCountClosedByUserName(start,end,customerId, claimServiceId,page, pageSize){
        return axios.get('/api/reporting/claim/user/closed',{params: {start:start,end:end,customerId:customerId, claimServiceId:claimServiceId,page:page,pageSize:pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsCountGroupedByOfficerUserName(start,end,customerId, claimServiceId,page, pageSize){
        return axios.get('/api/reporting/claim/officerUserName',{params: {start:start,end:end,customerId:customerId, claimServiceId:claimServiceId,page:page,pageSize:pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRate(year,month,isYear){
        return axios.get('/api/reporting/claim/taux', { params: { year: year, month:month,isYear:isYear} } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getClaimsRateByValidity(start,end,customerId, claimServiceId){
        return axios.get('/api/reporting/claim/rate-by-validity',{params: {start:start,end:end,customerId:customerId, claimServiceId:claimServiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getAlerts(page, pageSize,start,end,customerId, alertType){
        return axios.get('/api/reporting/alerts',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId, alertType: alertType} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    setClaimIsClosed(claimId, isClosed) {

        return axios.post('/api/reporting/claims/close/' + claimId + '/' + isClosed)
            .then(response => {
                if (response && response.data) return response.data;
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
        

    },

    getTurnoverByWeek (type, dbId) {
        return axios.get('/api/reporting/turnover/week' ,{ params: {  type: type, dbAgencyId: dbId }})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getTurnoverByMonth (type, dbId) {
        return axios.get('/api/reporting/turnover/month' ,{ params: {  type: type, dbAgencyId: dbId }})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getPercentTurnover (type, dbId) {
        return axios.get('/api/reporting/turnover/percent' ,{ params: { type: type, dbAgencyId: dbId }})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCustomerLanding (type, dbId) {
        return axios.get('/api/reporting/landing/' ,{ params: {  type: type, dbAgencyId: dbId }})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCustomerDeliveryNoteDownloadDaily(start, end, customerId){
        return axios.get('/api/customer-delivery-note-downloads/daily', {params: {start:start, end:end, customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCustomerDeliveryNoteDownload(page, pageSize, start, end, customerId){
        return axios.get('/api/customer-delivery-note-downloads/list', {params: {page: page, pageSize: pageSize, start:start, end:end, customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPartnerStats (type , year) {
        return axios.get('/api/reporting/partner-stats/' ,{ params: {  type: type , year:year}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPartnerStatsByMonth (type , year) {
        return axios.get('/api/reporting/partner-stats-month/' ,{ params: {  type: type , year:year}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    // article suggestions of "Recherche de mouvements" (id, ref, barcode, title, brand, type; no price or stock).
    // undefined when the server predates this endpoint (the axios interceptor swallows the 404)
    findMovementItems (search, limit) {
        return axios.get('/api/reporting/delivered-Item/items', { params: { search: search, limit: limit } })
        .then(response => {
            if (response && Array.isArray(response.data)) return response.data
        })
    },
    getDeliveredItemByCustomer (type ,itemRef,  customerId) {
        return axios.get('/api/reporting/delivered-Item/customer/' ,{ params: {  type: type  ,itemRef:itemRef , customerId:customerId }})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    exportPartnerStatsXls(type, year) {
        return axios.get('/api/reporting/partner-stats/export/xls', {
            params: { type: type, year: year },
            responseType: 'blob'
        })
        .then(response => {

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            let fileName = 'partner_stats.xlsx';
            const disposition = response.headers['content-disposition'];

            if (disposition) {

                const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/);
                if (utf8Match && utf8Match[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else {
                    const asciiMatch = disposition.match(/filename="?([^"]+)"?/);
                    if (asciiMatch && asciiMatch[1]) {
                        fileName = asciiMatch[1];
                    }
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', fileName);

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
    },

    exportPartnerStatsPdf(type, year) {
    return axios.get('/api/reporting/partner-stats/export/pdf', {
        params: { type: type, year: year },
        responseType: 'blob'
    })
    .then(response => {

        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });

        let fileName = 'partner_stats.pdf';
        const disposition = response.headers['content-disposition'];

        if (disposition) {

            const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/);
            if (utf8Match && utf8Match[1]) {
                fileName = decodeURIComponent(utf8Match[1]);
            } else {
                const asciiMatch = disposition.match(/filename="?([^"]+)"?/);
                if (asciiMatch && asciiMatch[1]) {
                    fileName = asciiMatch[1];
                }
            }
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    })
    .catch(error => {
        Vue.prototype.$snotify.error(error);
    });
}
}
